// Book a site visit: name, phone, a date and time. The address needs no
// "tenant" any more (the company is the website's own); ?tenant= still works.
import { useState } from 'react';
import { api } from '../lib/api.js';
import { useSite } from '../lib/site-context.jsx';

const today = () => new Date().toISOString().slice(0, 10);

export default function Visit({ data }) {
  const { settings } = useSite();
  const project = data.project;
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const tenant = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('tenant') : null;

  const submit = async (e) => {
    e.preventDefault();
    const f = e.currentTarget;
    setBusy(true);
    setError('');
    try {
      await api(`/api/site-visits${tenant ? `?tenant=${encodeURIComponent(tenant)}` : ''}`, {
        method: 'POST',
        body: JSON.stringify({
          name: f.name.value.trim(),
          phone: f.phone.value.trim(),
          email: f.email.value.trim() || undefined,
          project_id: project?.id || undefined,
          preferred_date: f.preferred_date.value,
          preferred_time: f.preferred_time.value || undefined,
          notes: f.notes.value.trim() || undefined,
        }),
      });
      setDone(true);
    } catch (err) { setError(err.message || 'Submission failed. Please try again.'); } finally { setBusy(false); }
  };

  if (done) {
    return (
    <section className="section" id="success-view">
        <div className="wrap narrow">
          <div className="success-card" role="status">
            <div className="checkmark" aria-hidden="true">✓</div>
            <h1>Visit request submitted!</h1>
            <p>We&apos;ve received your request and will confirm the visit date shortly. Our team will call you to finalize the time.</p>
            <p><a className="btn btn-outline btn-sm" href="/projects">Browse more projects</a></p>
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="section" id="form-view">
      <div className="wrap narrow">
        {project && <span className="status-pill" id="project-badge">{project.name}</span>}
        <h1>Book a site visit</h1>
        <p className="page-lede" id="hero-sub">{project ? `Schedule a visit to ${project.name} and speak with our team.` : `Schedule a time to visit the property and speak with the ${settings.company_name || ''} team.`}</p>
        <form className="form-panel" id="visit-form" onSubmit={submit}>
          <div className="form-grid">
            <div className="field"><label htmlFor="vf-name">Full name *</label><input id="vf-name" name="name" required autoComplete="name" placeholder="Your name" /></div>
            <div className="field"><label htmlFor="vf-phone">Phone *</label><input id="vf-phone" name="phone" type="tel" inputMode="tel" required autoComplete="tel" placeholder="+91 99999 99999" /></div>
            <div className="field full"><label htmlFor="vf-email">Email <span className="muted">(optional)</span></label><input id="vf-email" name="email" type="email" autoComplete="email" placeholder="you@example.com" /></div>
            <div className="field"><label htmlFor="vf-date">Preferred date *</label><input id="vf-date" name="preferred_date" type="date" required min={today()} defaultValue={today()} /></div>
            <div className="field"><label htmlFor="vf-time">Preferred time <span className="muted">(optional)</span></label><input id="vf-time" name="preferred_time" type="time" /></div>
            <div className="field full"><label htmlFor="vf-notes">Notes / requirements <span className="muted">(optional)</span></label><textarea id="vf-notes" name="notes" rows={3} placeholder="Anything specific you'd like to see or discuss" /></div>
          </div>
          <div className="form-msg error" id="visit-msg" role="alert">{error}</div>
          <div className="form-actions"><button className="btn btn-rust" type="submit" id="visit-btn" disabled={busy}>{busy ? 'Submitting…' : 'Request site visit'}</button></div>
        </form>
      </div>
    </section>
  );
}
